export default __webpack_public_path__ + "static/media/profilepic.23b81bb4.jpg";